import React, { useRef } from "react";
import { gsap } from "gsap";
import IntroBackground from "../../../assets/svg/IntroBackground";
import useFlowStore from "../../store/flowStore";
import CameraManager from "../../manager/CameraManager";
import { useGSAP } from "@gsap/react";
import TransitionBackground from "../../../assets/svg/TransitionBackground";

gsap.registerPlugin(useGSAP);

export default function TransitionUI() {
  const { nextStep, playCurrentAudio, setSceneVisible } = useFlowStore.getState();
  const uiRef = useRef();

  useGSAP(() => {
    const clouds = gsap.utils.toArray(".introBackgroundSVG path");

    // Assure que tous sont cachés
    gsap.set(clouds, { visibility: "hidden", opacity: 0 });
    gsap.set(uiRef.current, { autoAlpha: 0 }); // assure opacité 0 dès le début

    const tl = gsap.timeline({ delay: 0.1 });

    console.log("UI DOM ready", uiRef.current);

    // FADE IN DE L'UI
    tl.to(uiRef.current, {
      autoAlpha: 1,
      duration: 0.6,
      ease: "power2.out",
      onComplete: () => {
        // Décale le changement de scène après l'apparition de la transition
        // ACTIVER LA SECONDE SCENE EN ARRIÈRE-PLAN
        setTimeout(() => {
          setSceneVisible("hub", false);
          setSceneVisible("secondaryScene", true);
        }, 2000);
      },
    });

    // ANIMATION DES NUAGES
    tl.to(clouds, {
      visibility: "visible",
      opacity: 0.8,
      scaleX: () => gsap.utils.random(0.8, 1.5),
      scaleY: () => gsap.utils.random(0.8, 1.2),
      skewX: () => gsap.utils.random(-3, 3),
      skewY: () => gsap.utils.random(-5, 5),
      transformOrigin: "50% 50%",
      duration: 0.3,
      ease: "power2.inOut",
      stagger: 0.03,
      onComplete: () => {
        if (useFlowStore.getState().currentStep === 5) {
          // PLAY AUDIO : TRANSITION UI
          playCurrentAudio(() => {
            // FADE OUT CLOUDS
            gsap.to(clouds, {
              opacity: 0,
              duration: 0.5,
              ease: "power1.out",
              stagger: 0.02,
            });

            // FADE OUT UI : TRANSITION DISAPPEAR
            gsap.to(uiRef.current, {
              autoAlpha: 0,
              duration: 0.5,
              ease: "power1.out",
              onComplete: () => {
                nextStep(() => {
                  console.log("Transition UI dispear");
                }, {skipReset: true, skipSwitch: true});
              }
            });
          });
        }
      },
    });
  }, []);

  return (
    <div ref={uiRef} className="transitionUI">
      <TransitionBackground />
    </div>
  );
}
